import React from 'react';
import { withTranslation } from 'react-i18next';
import ListManual from './ListManual';
import './manuals.css';

function AppToApp({ t }) {
    const manuals = [
        {
            "url": "https://owncloud.signaturit.com/s/9iubf0rOnGSZuI4",
            "title": t('manuals.appToApp.windowsApp'),
            "description": t('manuals.appToApp.windowsAppInfo')
        },
        {
            "url": "https://owncloud.signaturit.com/s/rlkhYCLqpQfBtry",
            "title": t('manuals.appToApp.iOSApp'),
            "description": t('manuals.appToApp.iOSAppInfo')
        },
        {
            "url": "https://owncloud.signaturit.com/s/pQr9BL4ZOI0dLrJ",
            "title": t('manuals.appToApp.androidApp'),
            "description": t('manuals.appToApp.androidAppInfo')
        }
    ];

    return <ListManual links={manuals} />;
}

export default withTranslation()(AppToApp);